module.exports = __webpack_public_path__ + "img/dron-icon.2f8f0993.png";